import {
  AdvisorCard,
  CreditsPurchaseModal,
  recommendedAdvisors,
  useAdvisorActions,
} from "@/features/advisors"
import { useChat } from "@/features/chat"

/** "Need more guidance?" — a horizontal slider of advisor cards (reused as-is). */
export function GuidanceSection() {
  const { userMainSubscriptionId } = useChat()
  const { handleChatWithAdvisor, handleAdvisorInner, isPaywallOpen, closePaywall } =
    useAdvisorActions()

  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="font-display text-2xl font-medium text-purple-light">Need more guidance?</h2>
        <p className="font-body text-base text-purple-light/70">
          Ask an advisor about your report and get personal answers to your questions
        </p>
      </div>

      <div className="-mx-4 flex gap-4 overflow-x-auto px-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {recommendedAdvisors.map((advisor) => (
          <div key={advisor.assistantId} className="h-[344px] w-[240px] shrink-0">
            <AdvisorCard
              advisor={advisor}
              buttonTitle="Start chat"
              onClick={() => handleAdvisorInner(advisor)}
              onButtonClick={() => handleChatWithAdvisor(advisor)}
            />
          </div>
        ))}
      </div>

      <CreditsPurchaseModal
        isOpen={isPaywallOpen}
        onClose={closePaywall}
        userMainSubscriptionId={userMainSubscriptionId}
      />
    </section>
  )
}
